export default __webpack_public_path__ + "static/media/ic_pending-kyb.fc727a2d.svg";